// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-content {
  flex: 1 1;
  padding: 16px 40px 40px 40px;
  position: relative;
  z-index: 1;
}

/* ── Main Greeting Bar ── */
.dashboard__welcome-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.dashboard__greeting-text {
  font-family: var(--font-family);
  font-weight: 700;
  font-size: 1.85rem;
  color: var(--text-primary);
  letter-spacing: -0.8px;
  margin: 0;
  animation: slide-in-greeting 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slide-in-greeting {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ── View Mode Switcher ── */
.dashboard__view-switcher {
  display: flex;
  background: var(--bg-glass);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  padding: 3px;
  gap: 2px;
}

.dashboard__view-btn {
  width: 34px;
  height: 34px;
  border-radius: 6px;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.dashboard__view-btn:hover {
  color: var(--text-primary);
  background: var(--bg-glass-hover);
}

.dashboard__view-btn.active {
  color: var(--text-primary);
  background: var(--bg-glass-hover);
}

/* ── Accordion List Categories ── */
.dashboard__sections-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.dashboard__section-accordion {
  display: flex;
  flex-direction: column;
}

.dashboard__section-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: var(--bg-glass);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  margin-bottom: 12px;
  text-align: left;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

.dashboard__section-header:hover {
  background: var(--bg-glass-hover);
  border-color: var(--border-subtle);
}

.dashboard__section-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.dashboard__section-title {
  font-family: var(--font-family);
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
}

.dashboard__section-badge {
  font-size: 0.76rem;
  font-weight: 500;
  color: var(--text-muted);
  background: var(--bg-glass-hover);
  padding: 2px 8px;
  border-radius: 4px;
}

.dashboard__section-arrow {
  color: var(--text-muted);
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.dashboard__section-arrow.rotated {
  transform: rotate(180deg);
  color: var(--text-primary);
}

/* Accordion Body Grid and List styles */
.dashboard__section-body {
  animation: expand-fade 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes expand-fade {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dashboard__section-body--grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 16px;
}

.dashboard__section-body--list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Adjust card layout in list mode */
.dashboard__section-body--list .app-card {
  aspect-ratio: auto;
  flex-direction: row;
  justify-content: flex-start;
  padding: 16px 24px;
  gap: 20px;
  text-align: left;
}

.dashboard__section-body--list .app-card__logo-wrapper {
  margin-bottom: 0;
  height: 40px;
  width: 40px;
  justify-content: flex-start;
}

.dashboard__section-body--list .app-card__logo-svg {
  width: 38px;
  height: 38px;
}

.dashboard__section-body--list .app-card__logo-container {
  padding: 4px 10px;
}

.dashboard__section-body--list .autocab-text-top {
  font-size: 0.95rem;
}

.dashboard__section-body--list .autocab-text-bottom {
  font-size: 0.55rem;
}

.dashboard__section-body--list .app-card__title {
  text-align: left;
  font-size: 1.05rem;
}

/* Empty placeholder grids */
.dashboard__empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  background: var(--bg-glass);
  border-radius: var(--radius-lg);
  color: var(--text-muted);
  gap: 8px;
  font-size: 0.9rem;
}

/* ── Global Search Empty states ── */
.dashboard__global-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 80px 40px;
  background: var(--bg-glass);
  border-radius: var(--radius-xl);
  border: 1px dashed var(--border-subtle);
  margin-top: 20px;
  gap: 12px;
}

.dashboard__global-empty h2 {
  font-family: var(--font-family);
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--text-secondary);
}

.dashboard__global-empty p {
  font-size: 0.92rem;
  color: var(--text-muted);
  max-width: 400px;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,4BAA4B;EAC5B,kBAAkB;EAClB,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;EACtB,SAAS;EACT,+DAA+D;AACjE;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,2BAA2B;EAC3B,sCAAsC;EACtC,+BAA+B;EAC/B,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,sCAAsC;EACtC,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,wDAAwD;AAC1D;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,wCAAwC;AACxC;EACE,yDAAyD;AAC3D;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;EAC3B,+BAA+B;EAC/B,wBAAwB;EACxB,QAAQ;EACR,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,+BAA+B;EAC/B,uCAAuC;EACvC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;AACX","sourcesContent":[".dashboard-content {\n  flex: 1;\n  padding: 16px 40px 40px 40px;\n  position: relative;\n  z-index: 1;\n}\n\n/* ── Main Greeting Bar ── */\n.dashboard__welcome-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.dashboard__greeting-text {\n  font-family: var(--font-family);\n  font-weight: 700;\n  font-size: 1.85rem;\n  color: var(--text-primary);\n  letter-spacing: -0.8px;\n  margin: 0;\n  animation: slide-in-greeting 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes slide-in-greeting {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ── View Mode Switcher ── */\n.dashboard__view-switcher {\n  display: flex;\n  background: var(--bg-glass);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  padding: 3px;\n  gap: 2px;\n}\n\n.dashboard__view-btn {\n  width: 34px;\n  height: 34px;\n  border-radius: 6px;\n  color: var(--text-muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.dashboard__view-btn:hover {\n  color: var(--text-primary);\n  background: var(--bg-glass-hover);\n}\n\n.dashboard__view-btn.active {\n  color: var(--text-primary);\n  background: var(--bg-glass-hover);\n}\n\n/* ── Accordion List Categories ── */\n.dashboard__sections-list {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.dashboard__section-accordion {\n  display: flex;\n  flex-direction: column;\n}\n\n.dashboard__section-header {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  background: var(--bg-glass);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  margin-bottom: 12px;\n  text-align: left;\n  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.dashboard__section-header:hover {\n  background: var(--bg-glass-hover);\n  border-color: var(--border-subtle);\n}\n\n.dashboard__section-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.dashboard__section-title {\n  font-family: var(--font-family);\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.dashboard__section-badge {\n  font-size: 0.76rem;\n  font-weight: 500;\n  color: var(--text-muted);\n  background: var(--bg-glass-hover);\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.dashboard__section-arrow {\n  color: var(--text-muted);\n  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.dashboard__section-arrow.rotated {\n  transform: rotate(180deg);\n  color: var(--text-primary);\n}\n\n/* Accordion Body Grid and List styles */\n.dashboard__section-body {\n  animation: expand-fade 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes expand-fade {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.dashboard__section-body--grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 16px;\n}\n\n.dashboard__section-body--list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n/* Adjust card layout in list mode */\n.dashboard__section-body--list .app-card {\n  aspect-ratio: auto;\n  flex-direction: row;\n  justify-content: flex-start;\n  padding: 16px 24px;\n  gap: 20px;\n  text-align: left;\n}\n\n.dashboard__section-body--list .app-card__logo-wrapper {\n  margin-bottom: 0;\n  height: 40px;\n  width: 40px;\n  justify-content: flex-start;\n}\n\n.dashboard__section-body--list .app-card__logo-svg {\n  width: 38px;\n  height: 38px;\n}\n\n.dashboard__section-body--list .app-card__logo-container {\n  padding: 4px 10px;\n}\n\n.dashboard__section-body--list .autocab-text-top {\n  font-size: 0.95rem;\n}\n\n.dashboard__section-body--list .autocab-text-bottom {\n  font-size: 0.55rem;\n}\n\n.dashboard__section-body--list .app-card__title {\n  text-align: left;\n  font-size: 1.05rem;\n}\n\n/* Empty placeholder grids */\n.dashboard__empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n  background: var(--bg-glass);\n  border-radius: var(--radius-lg);\n  color: var(--text-muted);\n  gap: 8px;\n  font-size: 0.9rem;\n}\n\n/* ── Global Search Empty states ── */\n.dashboard__global-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 80px 40px;\n  background: var(--bg-glass);\n  border-radius: var(--radius-xl);\n  border: 1px dashed var(--border-subtle);\n  margin-top: 20px;\n  gap: 12px;\n}\n\n.dashboard__global-empty h2 {\n  font-family: var(--font-family);\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: var(--text-secondary);\n}\n\n.dashboard__global-empty p {\n  font-size: 0.92rem;\n  color: var(--text-muted);\n  max-width: 400px;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
